import angular from 'angular';

import tszCompanyActions from './tsz-company-actions';

const tszCompanyActionsModule = angular.module('tsz.components.tszCompanyActions', [])
  .component('tszCompanyActions', tszCompanyActions);

export default tszCompanyActionsModule;



// WEBPACK FOOTER //
// ./src/components/tsz-company-actions/tsz-company-actions.module.js